import { ClipboardDocumentListIcon } from '@heroicons/react/20/solid';
import { CalendarDaysIcon, WalletIcon } from '@heroicons/react/24/solid';
import React, { useState } from 'react';
import { startOfToday } from 'date-fns'
import CheckoutSchedule from './CheckoutSchedule';
import CheckoutConfirm from './CheckoutConfirm';
import CheckoutPayment from './CheckoutPayment';
import { Navigate, useLocation } from 'react-router-dom';

import { CheckoutContext } from './CheckoutContext';

function Checkout(props) {
  const {state: selectedPackage} = useLocation();

  const [currentPageIndex, setCurrentPageIndex] = useState(0);

  const [data, setData] = useState({
    ...selectedPackage, 
    schedules: {
      date: startOfToday(), 
      isDP: true, 
      time: []
    }, 
    addons: [], 
    contact: {}, 
    payment: {
      isDP: false, 
      DP: 0
    }, 
    paymentMethod: {}
  });

  const updateData = (data) => {
    setData(data);
  }

  if (selectedPackage === null) {
    return <Navigate to='/' replace={true} />;
  }

  const nextPage = () => {
    const currentPage = currentPageIndex + 1
    setCurrentPageIndex(currentPage)
  }

  return (
    <div className='max-w-7xl bg-white rounded-2xl flex flex-col mx-auto px-4 md:px-8 pb-4'>

      <div className='flex flex-col pb-6 md:pb-12 md:-translate-y-10 items-center'>

        {/* header navigation  */}
        <div className='grid grid-cols-3 items-center w-fit gap-x-8 md:gap-x-4 border-b-2 border-gray-500/50 border-dashed'>

          <div className='flex flex-col items-center justify-start translate-y-1/2 md:translate-y-[62px] -translate-x-1/2 '>
            <div className='bg-white p-2 md:py-4 md:px-6 rounded-lg'>
              <div className={`bg-amber-400 w-10 md:w-12 rounded-lg p-3 ring ring-offset-8 ring-transparent ${currentPageIndex === 0 ? '' : 'opacity-50'}`}>
                <CalendarDaysIcon className='w-4 md:w-6 text-gray-800' />
              </div>
            </div>
            <p className={`hidden md:inline-block text-sm text-[#343434] ${currentPageIndex === 0 ? 'font-semibold' : ''}`}>Pilih Sesi & Add On</p>
          </div>

          <div className='flex flex-col items-center justify-start translate-y-1/2 md:translate-y-[62px]'>
            <div className='bg-white p-2 md:py-4 md:px-6 rounded-lg'>
              <div className={`bg-amber-400 w-10 md:w-12 rounded-lg p-3 ring ring-offset-8 ring-transparent ${currentPageIndex === 1 ? '' : 'opacity-50'}`}>
                <ClipboardDocumentListIcon className='w-4 md:w-6 text-gray-800' />
              </div>
            </div>
            <p className={`hidden md:inline-block text-sm text-[#343434] ${currentPageIndex === 1 ? 'font-semibold' : ''}`}>Konfirmasi Pesanan</p>
          </div>

          <div className='flex flex-col items-center justify-start translate-y-1/2 md:translate-y-[62px] translate-x-1/2'>
            <div className='bg-white p-2 md:py-4 md:px-6 rounded-lg'>
              <div className={`bg-amber-400 w-10 md:w-12 rounded-lg p-3 ring ring-offset-8 ring-transparent ${currentPageIndex === 2 ? '' : 'opacity-50'}`}>
                <WalletIcon className='w-4 md:w-6 text-gray-800' />
              </div>
            </div>
            <p className={`hidden md:inline-block text-sm text-[#343434] ${currentPageIndex === 2 ? 'font-semibold' : ''}`}>Pembayaran</p>
          </div>

        </div>

      </div>

      <CheckoutContext.Provider value={{data, updateData}}>
        {/* Calendar and schedule body */}
        {currentPageIndex === 0 ?
          <CheckoutSchedule onNextPageConfirmed={() => { nextPage() }} />
          :
          currentPageIndex === 1 ?
            <CheckoutConfirm onNextPageConfirmed={() => { nextPage() }} />
            :
            <CheckoutPayment onNextPageConfirmed={() => { nextPage() }} />
        }
      </CheckoutContext.Provider>


    </div>
  );
}

export default Checkout;